/*
 * @Author: Yolo
 * @Date: 2024-07-02 09:13:23
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-02 09:15:28
 * @Desc 全球海区
 */
import L from 'leaflet'
import { merge } from 'lodash-unified'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import { globalSeaAreaSymbolArea } from '@map-sdk/sdk/plugins/AreaView/layer/GlobalSeaAreaSymbolData'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

class GlobalSeaAreaSymbol extends AreaViewBase {
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, merge({ isShowName: true }, options))
    this._data = globalSeaAreaSymbolArea
  }

  _show() {
    if (!this._data) {
      console.error('区域图形展示，请求无数据！')
      return this
    }

    let color = '#333'
    if ('MT_SATELLITE' === this._map.mapType) {
      color = '#fff'
    }

    for (let i = 0; i < this._data.length; ++i) {
      const multiGeometrys = this._data[i].multiGeometry.multiGeometry
      let name = this._data[i].name
      if (!CanvasShipUtils.isEmpty(name)) {
        name = `全球海区：${name}`
      }

      for (const multiGeometry of multiGeometrys) {
        const outerBoundaryIs = multiGeometry.outerBoundaryIs
        const innerBoundaryIs = multiGeometry.innerBoundaryIs
        this.drawBoundary(outerBoundaryIs, color, name)
        this.drawBoundary(innerBoundaryIs, '', name) // 假设内部边界也需要标题
      }
    }
    return this
  }

  drawBoundary(data: any[], color: string, title?: string) {
    for (const datum of data) {
      const coordinatesList = datum.coordinates.split(',')
      const latlngs1: L.LatLngExpression[] = []
      const latlngs2: L.LatLngExpression[] = []

      for (let j = 0; j < coordinatesList.length / 2; j++) {
        const lng = Number(coordinatesList[2 * j])
        const lat = Number(coordinatesList[2 * j + 1])
        latlngs1.push([lat, lng])
        latlngs2.push([lat, lng + 360])
      }

      const polygon1 = L.polygon(latlngs1, {
        color,
        opacity: 0.5,
        weight: 3,
        fillOpacity: 0,
        dashArray: [4, 8],
      })

      const polygon2 = L.polygon(latlngs2, {
        color,
        opacity: 0.5,
        weight: 3,
        fillOpacity: 0,
        dashArray: [4, 8],
      })

      if (this.options.isShowName && title) {
        const options: L.PopupOptions = {
          className: 'area-popup',
          closeButton: false,
        }

        const getHtml = (title: string): string => `
          <div class="box">
            <div class="title">${title}</div>
          </div>
        `

        polygon1.bindPopup(getHtml(title), options)
        polygon1.on('mousemove', (e) => {
          e.target.openPopup(e.latlng)
        })
        polygon1.on('mouseout', (e) => {
          e.target.closePopup()
        })

        polygon2.bindPopup(getHtml(title), options)
        polygon2.on('mousemove', (e) => {
          e.target.openPopup(e.latlng)
        })
        polygon2.on('mouseout', (e) => {
          e.target.closePopup()
        })
      }

      polygon1.addTo(this._map)
      this._areaLayers.push(polygon1)

      polygon2.addTo(this._map)
      this._areaLayers.push(polygon2)
    }
  }
}

// 实例化工厂方法
function globalSeaAreaSymbol(
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
) {
  return new GlobalSeaAreaSymbol(map, options)
}

export { GlobalSeaAreaSymbol, globalSeaAreaSymbol }
